module.exports = __webpack_public_path__ + "img/page2.8b63d8a0.png";